import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Home, User, Settings, Menu, X, Users, MapPin, Package, FileText, Crown, ShoppingCart, Building2 } from 'lucide-react'
import { videoAPI } from '../lib/api'
import { useAuth } from '../contexts/UserContext'

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const navigate = useNavigate()
  const { user, isAuthenticated, logout } = useAuth()

  // 加载分类
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await videoAPI.getCategories()
        setCategories(data.categories || [])
      } catch (error) {
        console.error('加载分类失败:', error)
      }
    }
    loadCategories()
  }, [])

  const handleLogin = () => {
    navigate('/login')
  }

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  return (
    <>
      {/* 移动端菜单按钮 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="md:hidden fixed top-4 right-4 z-50 p-2 bg-white rounded-lg shadow-lg"
        aria-label="菜单"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* 主菜单 */}
      <nav className={`
        fixed top-0 left-0 h-full w-64 bg-white shadow-xl z-40
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        md:translate-x-0 md:static md:h-auto md:w-auto md:shadow-none
        flex flex-col
      `}>
        {/* Logo - 灵动网球*/}
        <div className="p-6 border-b">
          <div className="flex items-center space-x-3">
            {/* 灵动网球Logo */}
            <div className="flex items-center space-x-3">
              <div className="relative">
                <img 
                  src="/logo/tennis-logo.svg" 
                  alt="灵动网球Logo" 
                  className="w-12 h-12"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">灵动网球</h1>
                <p className="text-sm text-gray-500">专业网球视频平台</p>
              </div>
            </div>
          </div>
        </div>

        {/* 主菜单 */}
        <div className="flex-1 p-4">
          <div className="space-y-2">
            <a
              href="/"
              className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-tennis-50 hover:text-tennis-600 rounded-lg transition-colors"
            >
              <Home size={20} />
              <span>首页视频</span>
            </a>
            <a
              href="/news"
              className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-tennis-50 hover:text-tennis-600 rounded-lg transition-colors"
            >
              <FileText size={20} />
              <span>网球新闻</span>
            </a>
            <a
              href="/clubs"
              className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-tennis-50 hover:text-tennis-600 rounded-lg transition-colors"
            >
              <Building2 size={20} />
              <span>网球俱乐部</span>
            </a>
            <a
              href="/coaches"
              className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-tennis-50 hover:text-tennis-600 rounded-lg transition-colors"
            >
              <Users size={20} />
              <span>网球教练</span>
            </a>
            <a
              href="/courts"
              className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-tennis-50 hover:text-tennis-600 rounded-lg transition-colors"
            >
              <MapPin size={20} />
              <span>网球场地</span>
            </a>
            <a
              href="/products"
              className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-tennis-50 hover:text-tennis-600 rounded-lg transition-colors"
            >
              <Package size={20} />
              <span>网球用品</span>
            </a>
          </div>

          {/* 视频分类 */}
          <div className="mt-8">
            <h3 className="px-4 text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
              视频分类
            </h3>
            <div className="space-y-1">
              {categories.map((category) => (
                <a
                  key={category.id}
                  href={`/?category=${category.id}`}
                  className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
                >
                  <span className="w-2 h-2 bg-tennis-400 rounded-full"></span>
                  <span>{category.name}</span>
                </a>
              ))}
            </div>
          </div>

          {/* 系统管理功能 */}
          <div className="mt-8">
            <h3 className="px-4 text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
              系统管理
            </h3>
            <div className="space-y-1">
              <a
                href="/admin"
                className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <Settings size={16} />
                <span>视频管理</span>
              </a>
              <a
                href="/admin/coaches"
                className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <Users size={16} />
                <span>教练管理</span>
              </a>
              <a
                href="/admin/courts"
                className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <MapPin size={16} />
                <span>场地管理</span>
              </a>
              <a
                href="/admin/products"
                className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <Package size={16} />
                <span>商品管理</span>
              </a>
              <a
                href="/admin/clubs"
                className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <Building2 size={16} />
                <span>俱乐部管理</span>
              </a>
              <a
                href="/admin/news"
                className="flex items-center space-x-3 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <FileText size={16} />
                <span>新闻管理</span>
              </a>
            </div>
          </div>
        </div>

        {/* 用户信息 */}
        <div className="p-4 border-t">
          {isAuthenticated && user ? (
            <div>
              <div className="flex items-center space-x-3 mb-3">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                  <User size={20} className="text-gray-500" />
                </div>
                <div className="flex-1">
                  <p className="font-medium">{user.display_name || user.username}</p>
                  <p className="text-xs text-gray-500">
                    {user.is_premium ? '高级会员' : '普通用户'}
                  </p>
                  <button 
                    onClick={handleLogout}
                    className="text-sm text-red-600 hover:text-red-700"
                  >
                    退出登录
                  </button>
                </div>
              </div>
              {/* 用户相关 */}
              <div className="border-t border-gray-100 pt-3 space-y-1">
                <a href="/user/dashboard"
                  className="flex items-center space-x-2 px-2 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">
                  <User size={16} />
                  <span>我的主页</span>
                </a>
                <a href="/membership"
                  className="flex items-center space-x-2 px-2 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">
                  <Crown size={16} />
                  <span>会员特权</span>
                </a>
                <a href="/cart"
                  className="flex items-center space-x-2 px-2 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">
                  <ShoppingCart size={16} />
                  <span>购物车</span>
                </a>
              </div>
            </div>
          ) : (
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                <User size={20} className="text-gray-500" />
              </div>
              <div className="flex-1">
                <p className="font-medium">未登录</p>
                <button 
                  onClick={handleLogin}
                  className="text-sm text-tennis-600 hover:text-tennis-700"
                >
                  去登录
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* 移动端遮罩 */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-30 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  )
}

export default Navigation
